import React from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { keys } from 'lodash'
import Select from 'react-select';
import TrendFacilitationHeader from '../../components/TrendFacilitationHeader'
import SideCountriesSelector from '../../components/SideCountriesSelector'
import SideCountryTrends from '../../components/SideCountryTrends'
import MapChart from '../../components/MapChart'
import BubbleChart from '../../components/BubbleChart'
import Modal from '../../components/Modal'
import { getCsvFile } from '../../utils/csvdownload'

import { getLatestFromData } from '../../state/selectors'
import { loadSevenPillars, unloadSevenPillars, loadLatestByIndicator,
  setSelectedCountry, setComparisonCountry,
  setSelectedCountryData, setComparisonCountryData } from '../../state/actions'

import './index.css'

const vizOptions = [
  { value: 'heatmap', label: 'Heatmap'},
  { value: 'bubbles', label: 'Bubbles'},
]

const INDICATORS_LIST = [
  'ETIA01',
  'ETIA02',
  'ETIB03',
  'ETIC04',
  'ETIC05',
  'ETIC06',
  'ETID07',
]

const SevenPillarsLegend = ({close}) => {
  return (
    <Modal close={close}>
        <img src="/legend/03.png" alt="Legend"/>
    </Modal>
  )
}

class SevenPillars extends React.PureComponent {

  state = {
    vizType : 'heatmap',
    legend: false,
  }

  componentWillMount(){
    this.props.loadSevenPillars()
    if(!this.props.latestDataByIndicator){
      this.props.loadLatestByIndicator()
    }
  }

  componentWillUnmount(){
    this.props.unloadSevenPillars()
    this.props.setSelectedCountry(null)
    this.props.setSelectedCountryData(null)
    this.props.setComparisonCountry(null)
    this.props.setComparisonCountryData(null)
  }

  handleVizTypeChange = (item) => {
    this.setState({vizType:item.value})
  }

  toggleLegend = (e) => {
    this.setState({legend:!this.state.legend})
  }

  downloadCsv =  (e) => {
    const { countries } = this.props
    getCsvFile(`seven-pillars.csv`, keys(countries).sort(), ['ETI'].concat(INDICATORS_LIST))
  }

  render() {
    const { indicators, latestDataByIndicator,
      selectedCountry, sevenPillarsData } = this.props

    const { vizType = 'heatmap' } = this.state

    const dataForMap = sevenPillarsData.reduce((acc, val)=>{
      acc[val.country] = val.v
      return acc
    }, {})

    const topic = 'ETI'

    //indicators list for SideCountryTrends
    const indicatorsList = INDICATORS_LIST
      .filter(code => indicators[code])
      .map(code => indicators[code])
      .filter(i => i.domain)

    return (
      <div>
        <TrendFacilitationHeader hasShowSort={ vizType === 'bubbles'} showSortMode={'sort'}/>
        <div className="h-container cf">
          { this.state.legend && <SevenPillarsLegend close={this.toggleLegend}/> }

          <div className="fl-l w-40-l ph4">
            <h2 className="text-blue text-medium">The enabling trade environment</h2>

            <div className="cf">
              <div className="w-third fl tc">
                <span onClick={this.toggleLegend}
                  className="explore-link link-lightblue underline pointer" to="/topics/ETIB03">LEGEND</span>
              </div>
              <div className="w-third fl tr">
                <a className="explore-link link-lightblue underline pointer" onClick={this.downloadCsv}>DOWNLOAD</a>
              </div>
            </div>

            { (selectedCountry === null) && (
              <div className="leftside-text text-gray">
                <p>
                While the efficiency and transparency of border processes are key factors to take into account when managing supply chains, other aspects are also relevant, including tariff structures, domestic infrastructure, logistics services and the broader operating environment of a country.
                </p>
                <p>
                Through 57 indicators grouped into seven pillars, the Enabling Trade Index provides an overview of the institutions, policies, infrastructures and services facilitating the free flow of goods over borders and to their destination in 136 economies.
                </p>
                <p>
                Results are expressed on a scale of 1 (worst) to 7 (best). <br/> You can visualise a summary of the results through a heatmap or a bubble graph, and click on each country for a more detailed analysis.
                </p>
              </div>
            ) }

            {/* graph type selector */}
            <div className="pa1 text-blue">
              <div className="blue-text">VISUALISE AS</div>
              <Select
                className="BubblesSelect"
                name="select_viztype"
                value={this.state.vizType}
                clearable={false}
                options={vizOptions}
                onChange={this.handleVizTypeChange}
              />
            </div>

            { (selectedCountry !== null) && (
              <div>
                <SideCountriesSelector/>
                <SideCountryTrends indicatorsList={indicatorsList}/>
              </div>
            ) }

          </div>

          <div className="fl-l w-60-l ph2">
            <div>
              <div className="cf pt2">
                <Link className="link-orange no-underline hero-top-link fl pa2 mb3" to="/trade-facilitation-policies">
                  <small>&lt; TRADE FACILITATION POLICIES</small>
                </Link>
              </div>
            </div>

            <div className="">
              { vizType === 'heatmap' && (
              <MapChart dataMap={dataForMap} height={500}
                topic="ETI"
                latestDataByIndicator={latestDataByIndicator}
                borderColor={'transparent'}
                decreasing={indicators[topic].rankDirection==='1'}
                emptyFill={"#eee"} minScale={0}/>
              )}
              { vizType === 'bubbles' && (
              <BubbleChart dataMap={dataForMap}
                latestDataByIndicator={latestDataByIndicator}
                borderColor={'transparent'}
                decreasing={indicators[topic].rankDirection==='1'}
                emptyFill={"#eee"} minScale={0}/>
              )}
            </div>

            {/* <div>
              <Link className="link-orange no-underline hero-bottom-link fl" to="/trade-facilitation-policies">
                <small>CLICK TO EXPLORE THE COUNTRY FACILITATION POLICIES</small>
              </Link>
              <span className="cf"></span>
            </div> */}

          </div>
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  countries: state.countries,
  indicators: state.indicators,
  selectedCountry: state.selectedCountry,
  selectedCountryData: state.selectedCountryData,
  comparisonCountry: state.comparisonCountry,
  comparisonCountryData: state.comparisonCountryData,
  sevenPillarsData: getLatestFromData(state.sevenPillars.data),
  latestDataByIndicator: state.latestDataByIndicator.data,
})

const mapDispatchToProps = { loadSevenPillars, unloadSevenPillars,
  loadLatestByIndicator, setComparisonCountry, setSelectedCountry,
  setSelectedCountryData, setComparisonCountryData, }
export default connect(mapStateToProps, mapDispatchToProps)(SevenPillars)



// WEBPACK FOOTER //
// ./src/pages/SevenPillars/index.js